<template>
  <div class="my-result">
    
    <div class="title">正在为你创建试卷答题卡，请耐心等待... </div>
    <div class="sub-title">{{ subTitle }}</div>
    <div class="sub-title">{{ subTitle1 }}</div>
    <div class="extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script setup>
import CryptoJS from 'crypto-js';
import { loginApi } from '@/api/login.js'
import { reactive, ref, toRef, toRefs } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'
import { useRoute, useRouter } from 'vue-router'
import { getBrand } from '@/api/activate.js'
import { message } from 'ant-design-vue'
import {   getTeacherPaper1  } from "@/api/paper.js"

 

let secretkey = 'abc'
const router = useRouter()
const route = useRoute()
let form = reactive({
 
})
 
onMounted(() => {
    let params = {
    edu_paper_id:route.query.edu_paper_id,
    is_kujc:1,
    
  }
  if(route.query.is_order_paper !== 'undefined'){
    params.is_order_paper = route.query.is_order_paper   
  } 
 doTeacherPaper(params)
})
// 教师试卷
const doTeacherPaper = async (params) => {
 
  const { data } = await getTeacherPaper1(params)
  let token =JSON.parse(window.localStorage.getItem('userInfo')).token
  console.log(token)
  if(data.list){
    router.push('/code?edu_paper_id='+data.list.edu_paper_id+'&id='+data.list.user_paper_id+'&token='+ token+'&is_order_paper='+route.query.is_order_paper)
  } 
 
}
 
const toCode = () => {
  router.push('/loginTeacherCode')
}
const toRegister = () => {
  router.push('/register')
}


</script>

<style lang="scss" scoped>
.my-result {
  text-align: center;
  padding: 40px;
  margin-top: 60%;
}
.icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 20px;
}
.title {
  font-size: 16px;
  // font-weight: bold;
  margin-bottom: 10px;
}
.sub-title {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}
.extra {
  margin-top: 20px;
}
</style>